<template>
  <div>
    <div v-if="loading">
      <MoonLoader class="loading"></MoonLoader>
    </div>

    <div v-else>
      <card-with-sides v-if="answerCopy" :withDoubleSides="doubleSide" :highlight="isHighlighted(answerCopy)">
        <div class="icon-big text-center" slot="header">
          <img class="opacity-60" :src="answerCopy.dashboard_element.icon_url" alt="" />
        </div>
        <div class="numbers" slot="content">
          <p>Answer</p>
          <span v-if="answerCopy.value" :style="{ color: defineValueStyle() }"
            >{{ getValue(answerCopy.value) }}
            <p v-if="answerCopy.question.unit.text">{{ answerCopy.question.unit.text }}</p>
            <p v-else>&nbsp;</p>
          </span>
          <span v-else :style="{ color: 'gray' }">
            <p>&minus;</p>
          </span>
        </div>
        <div class="stats" slot="footer">
          <div v-if="answer.dashboard_element.headline">
            {{ answer.dashboard_element.headline }}
          </div>
        </div>

        <div slot="header_back" class="cardCustom__side--back__question_block">
          <span>
            {{ answer.question.question_text }}
          </span>
        </div>
        <div slot="content_back">
          <AnswerField
            :question="answer.question"
            :answer="answer"
            :company="company"
            @saved="setValue($event)"
            :allow-empty="false"
          >
          </AnswerField>
        </div>
      </card-with-sides>
    </div>
  </div>
</template>

<script>
import ScoreController from '@/controllers/Score/ScoreController';
import MoonLoader from '@/components/svg/SvgLoaderMoon';
import StatsCard from '@/components/Cards/StatsCard';
import CardWithSides from '@/components/Cards/CardWithSides';
import AnswerField from '@/components/Questions/AnswerField';

export default {
  name: 'DashboardElementPrimary',
  components: { AnswerField, CardWithSides, StatsCard, MoonLoader },
  props: {
    answer: Object,
    company: Object,
    doubleSide: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      valueStyleObject: { color: '#73AB6B' },
      loading: false,
      value: null,
      answerCopy: null,
    };
  },
  async mounted() {
    this.loading = true;
    await this.setAnswer(this.answer);
    this.defineValueStyle();
    this.loading = false;
  },
  methods: {
    getValue(value) {
      let result = value;
      if (typeof value === 'object' && value !== null) result = value.name;
      if (typeof value === 'string') result = value;
      return result;
    },
    defineValueStyle() {
      let color = '#73AB6B';
      if (this.answerCopy.achieved_weight < this.answerCopy.question.question_weight / 2) {
        color = '#CF381E';
      }
      if (this.answerCopy.achieved_weight >= this.answerCopy.question.question_weight / 2) {
        color = '#FFC20E';
      }
      if (this.answerCopy.achieved_weight === this.answerCopy.question.question_weight) {
        color = '#73AB6B';
      }
      return color;
    },
    setValue(newVal) {
      this.answerCopy.value = newVal;
      this.calcScore(newVal);
    },
    async calcScore(value) {
      this.answerCopy.achieved_weight = await ScoreController.calculateScore(value, this.answerCopy.question);
      return this.answerCopy.achieved_weight;
    },
    async setAnswer(answer) {
      this.answerCopy = answer;
    },
    isHighlighted(answer) {
      let result = false;
      if (!answer.value) result = true;
      if (answer.highlight) result = true;
      return result;
    },
    checkSizeOfQuestion(question_text) {
      return question_text.length > 110;
    },
  },
};
</script>

<style scoped></style>
